/**
 * * @module pages/project-single.js
 */
import regeneratorRuntime from "regenerator-runtime";
import backbone from "backbone";
import $ from "jquery";
import _ from "underscore";
import Breadcrumb from "../components/breadcrumb";

const Project = Backbone.View.extend({
  el: $(document),
  events: {},

  initialize: function () {
    this.render();
  },

  render: function () {
    const breadcrumb = new Breadcrumb();
  },
});

export default Project;
